import { useTranslation } from "react-i18next";
import { StakeholderCard } from "./StakeholderCard";
import {
  CAROUSEL_TYPE
} from "../../../consts";
import { TypographyTitle } from "../../../styles/global_styles";
import {
  Carousel
} from "../../index";
import { TabsContentProps } from "../TabsContent.types";

export function TabsContentStakeholders({
  stakeholders
} :
  Pick<
    TabsContentProps,
    | "stakeholders"
  >
) {
  const { t } = useTranslation();

  return (
    <>
      <TypographyTitle>
        { t("stakeholders") }
      </TypographyTitle>
      { stakeholders && (
        <Carousel
          id={ "tabs-content-activities" }
          carouselType={ CAROUSEL_TYPE.ZOOM_RELATED }
          label={ "tabs-content-activities" }
        >
          { stakeholders.filter((stakeholder) => stakeholder.visStakeholder).map((stakeholder, index) => {
            return  (
              <StakeholderCard key={ `stakeholder_${index}` } stakeholder={ stakeholder } />
            );
          })
          }
        </Carousel>
      ) }
    </>
  );
}
